

import { useTranslation } from 'react-i18next'
import { Button, InputAdornment } from '@mui/material';
import {
    Container,
    Form,
    Title,
    Subtitle,
    SectionRow,
    SectionInput,
    ContainerInput,
    Input,
    Span,
    SpanLink,
    SectionBtn,
    LabelCustom,
    SubtitleCustom,
    ContainerLogin,
    CustomInput
} from './styles'

import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

export const UserNameSection = ({
    handleChange,
    isLoading,
    colors,
    messageError,
    nextStep,
    form
}) => {

    const { t } = useTranslation();

    return (
        <ContainerLogin>
            <SubtitleCustom>{t('login.title')}</SubtitleCustom>
            <SectionRow>
                <SectionInput>
                    <LabelCustom>{t('login.stepUsername')}</LabelCustom>
                    <CustomInput
                        name="username"
                        label={t('login.user')}
                        variant="outlined"
                        value={form.username}
                        placeholder={t('login.user')}
                        onChange={(e) => handleChange(e, 'username')}
                        required
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AlternateEmailIcon sx={{ color: colors.navbarColor }} /> 
                                </InputAdornment>
                            ),
                        }}
                    />
                </SectionInput>
            </SectionRow>

            <SectionRow>
                <SectionInput>
                    <Span>{messageError}</Span>
                </SectionInput>
            </SectionRow>

            <SectionBtn>
                <Button
                    variant="contained"
                    sx={{
                        color: colors.white,
                        backgroundColor: colors.buttonActionColor,
                        cursor: 'pointer',
                        padding: '.5em 0',
                        borderRadius: '5px',
                        display: 'inline-block',
                        justifyContent: 'center',
                        transition: 'all .3s ease-in-out',
                        width: '100%',
                        "&.MuiButton-outlined.Mui-disabled": {
                            background: colors.grayGraphic,
                            cursor: 'not-allowed',
                        },
                        "&:hover": {
                            backgroundColor: colors.buttonActionColor,
                            opacity: 0.8,
                            color: colors.white,
                            transition: 'all .3s ease',
                        },
                        '&:active': {
                            transition: 'all .3s ease',
                            opacity: '1',
                        },
                    }}
                    onClick={() => nextStep()}
                    disabled={isLoading}
                >
                    {t('login.stepper.next')}
                </Button>
            </SectionBtn>
        </ContainerLogin>
    )
}